import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/Address/AccessKeysActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/Address/AccountTabsActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/Address/Contract/OverviewActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/Address/NFTTxnsActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/Address/ReceiptActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/Address/TokenTxnsActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/Address/TransactionActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/common/ErrorMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/app/src/components/app/skeleton/address/tab.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
